import * as Models from "../../Models";
import * as Services from "../../Services";
import { Reference } from "../../Shared/Constants/Reference";

export interface ICostCalculationDirective extends ng.IScope {
  costCalculationDirective: CostCalculationDirective;
  costCalculationModel: Models.CostCalculation.EpcCalculation.IEpcCalculationResult;
  reconcileEpc: Models.CostCalculation.EpcCalculation.IEpcCalculationResult;
  rateAmendmentInProgress: boolean;
  showItcYear: boolean;
  calculationType: string;
}

export class CostCalculationDirective implements ng.IDirective {

  public static $inject = ["$state", "UserService"];
  public restrict = "E";
  public scope = {
    costCalculationModel: "=",
    reconcileEpc: "=",
    pendingEpc: "=",
    calculationType: "@",
  }

  public template = require("./cost-calculation-directive.html");

  public $scope: ICostCalculationDirective;
  public $state: angular.ui.IStateService;

  public costCalculationModel: Models.CostCalculation.EpcCalculation.IEpcCalculationResult;
  public reconcileEpc: Models.CostCalculation.EpcCalculation.IEpcCalculationResult;
  public rateAmendmentInProgress: boolean;
  public showItcYear: boolean = false;
  public calculationType: string;

  public roleList: Models.Auth.RoleList.RoleList;
  public canViewEpcCostsAndTotals: boolean;

  constructor($state: angular.ui.IStateService, private userService: Services.UserService.IUserService) {
    this.$state = $state;
    this.roleList = new Models.Auth.RoleList.RoleList();
    this.setCanSeeEpcPrice();
  }

  public link = ($scope: ICostCalculationDirective): void => {
    $scope.costCalculationDirective = this;
    this.$scope = $scope;
    this.costCalculationModel = $scope.costCalculationModel;

    this.$scope.$watch("costCalculationModel",
      () => {
        this.costCalculationModel = $scope.costCalculationModel;
      });
    this.$scope.$watch("reconcileEpc",
      () => {
        this.reconcileEpc = $scope.reconcileEpc;
      });
    this.$scope.$watch("rateAmendmentInProgress",
      () => {
        this.rateAmendmentInProgress = $scope.rateAmendmentInProgress;
      });
    this.$scope.$watch("calculationType",
      () => {
        this.calculationType = $scope.calculationType;
      });
  }

  public isReconcile = (): boolean => {
    return this.calculationType === Reference.ReconcileCalculationType;
  }

  public isSandbox = (): boolean => {
    return this.calculationType === Reference.SandboxCalculationType;
  }

  public isAssociate = (): boolean => {
    return this.calculationType === Reference.AssociateCalculationType;
  }

  public isAmendment = (): boolean => {
    return this.calculationType == Reference.AmendmentCalculationType;
  }

  private setCanSeeEpcPrice = (): void => {
    this.userService.isUserInRole(this.roleList.viewEpcCostsAndTotals)
      .then((viewEpcPricing) => {
        this.canViewEpcCostsAndTotals = viewEpcPricing;
      },
        () => {
          this.canViewEpcCostsAndTotals = false;
        });
  }
}

